import type { GameName } from '@/components/projects/games';
import { GameLoader } from '@/components/projects/games/game-loader';
import { Link } from 'react-router-dom';

interface MobileGame {
    id: GameName;
    title: string;
    icon: string;
    description: string;
}

export const MOBILE_GAMES: MobileGame[] = [
    {
        id: 'snake-game',
        title: 'Snake',
        icon: '🐍',
        description: 'Use the direction buttons to collect food and grow.',
    },
    { id: 'tic-tac-toe', title: 'Tic Tac Toe', icon: '⭕', description: 'Tap a square and challenge the computer.' },
    { id: 'memory-game', title: 'Memory', icon: '🧠', description: 'Tap cards to find all the matching pairs.' },
    {
        id: 'breakout-game',
        title: 'Breakout',
        icon: '🧱',
        description: 'Drag across the board to move the paddle and break bricks.',
    },
    {
        id: 'word-scramble',
        title: 'Word Scramble',
        icon: '🔤',
        description: 'Type your answer to unscramble words before time runs out.',
    },
];

export const MobileGames = () => (
    <section className='max-w-3xl mx-auto p-4 sm:p-6'>
        <h1 className='text-3xl font-bold text-vscode-accent mb-3'>Games</h1>
        <p className='text-vscode-text-muted mb-6'>Take a break and play. Choose a game to get started.</p>
        <div className='grid sm:grid-cols-2 gap-4'>
            {MOBILE_GAMES.map(game => (
                <Link
                    key={game.id}
                    to={`/Games/${game.id}.html`}
                    className='block rounded-lg border border-gray-600/30 bg-vscode-bg-secondary p-4 hover:border-vscode-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-vscode-accent'
                >
                    <h2 className='text-xl font-semibold mb-2'>
                        <span aria-hidden='true'>{game.icon} </span>
                        {game.title}
                    </h2>
                    <p className='text-sm text-vscode-text-muted'>{game.description}</p>
                </Link>
            ))}
        </div>
    </section>
);

export const MobileGamePage = ({ game }: { game: MobileGame }) => (
    <section>
        <Link to='/Games' className='inline-flex items-center min-h-11 px-4 text-vscode-accent hover:underline'>
            ← All games
        </Link>
        <GameLoader key={game.id} gameName={game.id} />
    </section>
);
